import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_audit_view",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "tranche",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_audit_view_button",
  "data-kt-drawer-close": "#kt_drawer_audit_view_close",
  "data-kt-drawer-width": "72.5vw"
}
const _hoisted_2 = {
  id: "kt_tranche",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_tranche_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Audit Log </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_audit_view_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_tranche_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_tranche_body",
  "data-kt-scroll-dependencies": "#kt_tranche_header, #kt_tranche_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "card-body p-2" }
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_tranche_scroll"
}
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_change_summery_scroll"
}
const _hoisted_9 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "bg-success text-light",
    scope: "col",
    style: {"text-align":"center","font-size":"16px","border":"0px solid","padding":"5px"}
  }, " Old Data ")
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_13 = {
  class: "bg-success text-light",
  scope: "col",
  style: {"text-align":"left","font-size":"12px","border":"0px solid","padding":"5px"}
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  class: "row",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "row d-flex" }
const _hoisted_18 = { class: "col-3" }
const _hoisted_19 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", {
    class: "bg-success text-light",
    scope: "col",
    style: {"text-align":"center","font-size":"16px","border":"0px solid","padding":"5px"}
  }, " New Data ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("table", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.oldauditLog, (info, index1) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index1 }, [
                              (Array.isArray(info))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", null, [
                                        _createElementVNode("table", _hoisted_12, [
                                          _createElementVNode("thead", null, [
                                            _createElementVNode("th", _hoisted_13, _toDisplayString(index1), 1)
                                          ]),
                                          _createElementVNode("tbody", null, [
                                            _createElementVNode("td", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.length, (value, keyindex) => {
                                                return (_openBlock(), _createElementBlock("td", {
                                                  key: keyindex,
                                                  style: {"border":"1px solid"}
                                                }, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info[
                                              keyindex
                                            ], (value2, index2) => {
                                                    return (_openBlock(), _createElementBlock("tr", { key: index2 }, [
                                                      _createElementVNode("td", null, _toDisplayString(index2) + " --> " + _toDisplayString(value2), 1)
                                                    ]))
                                                  }), 128))
                                                ]))
                                              }), 128))
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]))
                                : (
                              !Array.isArray(info) &&
                              typeof info === 'object' &&
                              info !== null
                            )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("h4", null, _toDisplayString(index1), 1),
                                          _createElementVNode("div", _hoisted_15, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info, (value2, index2) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: index2,
                                                class: "col-3",
                                                style: {"border":"1px solid"}
                                              }, [
                                                _createElementVNode("p", null, _toDisplayString(index2) + " : " + _toDisplayString(value2), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                          _createElementVNode("p", null, _toDisplayString(index1) + " : " + _toDisplayString(info), 1)
                                        ])
                                      ])
                                    ]))
                            ], 64))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("table", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newauditLog, (info, index2) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index2 }, [
                              _createElementVNode("td", null, _toDisplayString(index2) + " --> " + _toDisplayString(info), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ]))
}